import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './PlaceRanking.css';
import { abbreviate } from '../../utils/utils';
import withStyles from '../../decorators/withStyles';
import {commas} from "../../utils/utils";


class PlaceRanking extends Component {

  static propTypes = {
    impactName: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    impactPosttransform: PropTypes.func,
    // impactPretransform: PropTypes.func.isRequired,
    placeList: PropTypes.array.isRequired,
    impactPct: PropTypes.bool.isRequired,
  };

  render() {
    const { impactPosttransform, impactPct } = this.props;
    // const { impactPretransform, impactPosttransform, impactPct } = this.props;

    return <div className="PlaceRanking">
      <h4>Top threats on map</h4>
      <table>
        <tbody>
        {this.props.placeList.map(place => {
          var val;
          if (impactPct) {
            val = place.value.toFixed(1);
          } else {
            if (place.value < 1) {
              val = place.value.toPrecision(1);
            } else {
              val = place.value.toFixed(0);
            }
          }
          return (
            <tr key={place.name} onClick={this.props.handleClick.bind(this, place.path)}>
              <td>{abbreviate(place.name)}</td>
              <td className="value" dangerouslySetInnerHTML={{__html:
                ((impactPosttransform && !impactPct) ?
                  `<var>${impactPosttransform(val).split(" ")[0]}</var> ${impactPosttransform(val).split(" ").slice(1).join(" ")}`
                  : commas(val))
              }} />
            </tr>
          )})}
        </tbody>
      </table>
    </div>;
  };

}

export default withStyles(styles)(PlaceRanking);
